type Status = 'unread' | 'reading' | 'archived' | 'filed';

const statusConfig: Record<Status, { label: string; color: string }> = {
  unread:   { label: 'Unread',   color: '#F59E0B' },
  reading:  { label: 'Reading',  color: '#10B981' },
  archived: { label: 'Archived', color: '#3B82F6' },
  filed:    { label: 'Filed',    color: '#8B5CF6' }
};

export function StatusBadge({ status }: { status: Status }) {
  const cfg = statusConfig[status] ?? statusConfig.unread;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium"
      style={{ background: `${cfg.color}20`, color: cfg.color }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: cfg.color }} />
      {cfg.label}
    </span>
  );
}
